import React from 'react';
import * as styles from './Hr.module.scss';
const Hr = () => {
  return /*#__PURE__*/React.createElement("hr", {
    className: styles.root
  });
};
export default Hr;